import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6

import { Popover } from 'antd';

const configuracioPopoverPerDefecte = {
    posicioPopover: 'top',
    fletxaPopoverAlCentreDelBoto: false
};

class PopoverGeneric extends Component {

    constructor(props) {
        super(props);
        this.obrirPopover = this.obrirPopover.bind(this);
        this.tancarPopover = this.tancarPopover.bind(this);
        this.togglePopover = this.togglePopover.bind(this);
        this.state = { visible: false };
    }

    obrirPopover() {
        if (!this.state.visible) {
            this.setState({visible: true});
        }
    }

    tancarPopover() {
        if (this.state.visible) {
            this.setState({visible: false});
        }
    }

    togglePopover() {
        this.setState({visible: !this.state.visible});
    }

    afegirControlsGestioPopoverAElementBase(elementBase) {
        const propsControlPopover = {
            onMouseEnter: this.obrirPopover,
            onMouseLeave: this.tancarPopover,
            onTouchEnd: this.togglePopover
        };

        const elementBaseAmbEvents = React.cloneElement(elementBase, propsControlPopover);
        return elementBaseAmbEvents;
    }

    render() {

        const { titolPopover, contingutPopover, elementBase, configuracioPopover } = this.props;
        const configuracioPopoverAmbOpcionsNoInformadesPerDefecte = { ...configuracioPopoverPerDefecte, ...configuracioPopover };
        const { visible } = this.state;

        const posicioPopover = configuracioPopoverAmbOpcionsNoInformadesPerDefecte.posicioPopover;
        const fletxaPopoverAlCentreDelBoto = configuracioPopoverAmbOpcionsNoInformadesPerDefecte.fletxaPopoverAlCentreDelBoto;

        if (!contingutPopover) {
            return elementBase;
        }

        return (
            <Popover
                visible={visible}
                placement={posicioPopover}
                title={titolPopover}
                content={contingutPopover}
                arrowPointAtCenter={fletxaPopoverAlCentreDelBoto}>
                {this.afegirControlsGestioPopoverAElementBase(elementBase)}
            </Popover>
        );
    }
}

PopoverGeneric.propTypes = {
    titolPopover: PropTypes.string,
    contingutPopover: PropTypes.node,
    elementBase: PropTypes.node.isRequired,
    configuracioPopover: PropTypes.object
};

export default PopoverGeneric;



// WEBPACK FOOTER //
// ./src/components/commons/popoverGeneric.js